import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { TiTimes } from "react-icons/ti";

export default function RaiseIssueModal({ show, handleClose }) {
  const [issue, setIssue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(issue); // keep your submit logic here
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="raiseIssueModal"
    >
      <Modal.Header
        style={{
          borderBottom: "1px solid #e5e7eb",
          padding: "22px 22px",
          position: "relative"
        }}
      >
        <Modal.Title
          style={{
            fontSize: "22px",
            fontWeight: "700",
            color: "#1e2b4d"
          }}
        >
          Raise Issue
        </Modal.Title>

        <button
          onClick={handleClose}
          style={{
            position: "absolute",
            right: "18px",
            top: "18px",
            border: "none",
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            background: "#6b7280",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <TiTimes size={20} />
        </button>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body
          style={{
            padding: "24px 20px 20px"
          }}
        >
          <Form.Group>
            <Form.Label
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#334155",
                marginBottom: "12px"
              }}
            >
              Description
              <span style={{ color: "#ef4444" }}> *</span>
            </Form.Label>

            <Form.Control
              as="textarea"
              rows={6}
              value={issue}
              onChange={(e) => setIssue(e.target.value)}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                resize: "none",
                minHeight: "135px",
                boxShadow: "none"
              }}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer
          style={{
            borderTop: "1px solid #e5e7eb",
            padding: "16px 20px",
            justifyContent: "flex-end",
            gap: "10px"
          }}
        >
          <Button
            type="button"
            onClick={handleClose}
            style={{
              background: "#ffffff",
              border: "1px solid #d1d5db",
              color: "#1f2937",
              padding: "10px 18px",
              borderRadius: "6px",
              fontSize: "16px"
            }}
          >
            Cancel
          </Button>

          <Button
            type="submit"
            style={{
              background: "#f97316",
              border: "none",
              padding: "10px 20px",
              borderRadius: "6px",
              fontSize: "16px",
              fontWeight: "500"
            }}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}